import * as React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

import { NavItem } from '../NavItem';
import { NavButton, NavOption } from '../types';
import { BREAKPOINTS, COLORS } from '../styles';
import { Button } from '../Button';

const NavContainer = styled.div`
  display: flex;
  margin: auto 0 auto auto;
  align-items: center;
  height: 48px;

  ${BREAKPOINTS.SMALL} {
    height: 56px;
  }
  ${BREAKPOINTS.MEDIUM} {
    height: 64px;
  }

  button,
  div {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SecondaryButton = styled(Button)`
  font-weight: bold;
  font-size: 19px;
  height: 40px;
  margin: 0 8px;
`;

type Props = {
  navigationOptions?: NavOption[];
  secondaryButton?: NavButton;
};

const RightSideNav = ({ navigationOptions, secondaryButton }: Props): React.ReactElement<Props> => {
  const preventFocusOnClick = (e: any) => {
    e.preventDefault();
  };
  const getNavItem = (navOption: NavOption) => {
    if (navOption?.disabled) {
      return (
        <NavItem as={Button} className="disabled" key={navOption?.label}>
          {navOption?.label}
        </NavItem>
      );
    } else {
      return (
        <NavItem
          as={NavLink}
          exact={navOption?.exact}
          to={navOption?.to || ''}
          key={navOption?.label}
          onMouseDown={preventFocusOnClick}
          onClick={() => {
            if (navOption?.onClick) {
              navOption?.onClick();
            }
          }}>
          {navOption?.label}
        </NavItem>
      );
    }
  };
  return (
    <NavContainer>
      {navigationOptions?.reverse().map(no => getNavItem(no))}

      {secondaryButton && (
        <SecondaryButton variant="secondary" onClick={secondaryButton?.action}>
          {secondaryButton.label}
        </SecondaryButton>
      )}
    </NavContainer>
  );
};

export default RightSideNav;
